
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { LucideIcon, DollarSign } from "lucide-react";
import { cn } from "@/lib/utils";
import { format } from "date-fns";

interface MetricCardProps {
  title: string;
  value: string | number;
  icon?: LucideIcon;
  iconColorClass?: string;
  iconBgClass?: string;
  isLoading?: boolean;
  className?: string;
}

export const MetricCard = ({
  title,
  value,
  icon: Icon = DollarSign,
  iconColorClass = "text-blue-600",
  iconBgClass = "bg-blue-100",
  isLoading = false,
  className,
}: MetricCardProps) => {
  console.log("MetricCard rendering:", { title, value }); // Keep logging

  // Get current month and year
  const currentDate = new Date();
  const monthYearDisplay = format(currentDate, 'MMMM yyyy');
  
  // Replace "This Month" with current month and year if present in title
  const displayTitle = title.includes("This Month") 
    ? title.replace("This Month", monthYearDisplay)
    : title;

  return (
    <Card className={cn(
      "p-3 sm:p-4 md:p-6 transition-all duration-200 rounded-xl shadow-sm hover:shadow-lg",
      "border min-w-[220px] sm:min-w-[250px] w-full",
      className
    )}>
      <div className="flex items-start justify-between space-x-2 sm:space-x-4">
        <div className="flex-1 min-w-0">
          {isLoading ? (
            <Skeleton className="h-4 w-24 mb-2" />
          ) : (
            <p className="text-xs sm:text-sm md:text-base font-medium text-muted-foreground truncate mb-2">
              {displayTitle}
            </p>
          )}

          {isLoading ? (
            <Skeleton className="h-8 w-36" />
          ) : (
            <p className="text-lg sm:text-xl md:text-2xl font-bold truncate mt-1 text-blue-700">
              {value}
            </p>
          )}
        </div>

        <div className={cn(
          "p-2 sm:p-3 rounded-lg transition-transform duration-200 hover:scale-105 flex-shrink-0",
          iconBgClass
        )}>
          <Icon className={cn(
            "h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8",
            iconColorClass
          )} />
        </div>
      </div>
    </Card>
  );
};
